export default "__VITE_ASSET__DNVfN7s3__"